import { render } from "./edit-customer-form.vue?vue&type=template&id=0b266978&scoped=true&ts=true"
import script from "./edit-customer-form.vue?vue&type=script&lang=ts"
export * from "./edit-customer-form.vue?vue&type=script&lang=ts"

import "./edit-customer-form.vue?vue&type=style&index=0&id=0b266978&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b266978"]])

export default __exports__